export const roomTypes = ["Inter-connecting", "Physically challenged"];
